import Vue from 'vue';
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons';
import LinkMapping from './components/LinkMapping';
import ProfileHealth from './components/ProfileHealth';
import WizardSide from './components/WizardSide';
import NotificationHandler from './components/NotificationHandler';
import HealthStatusIndicator from './components/HealthStatusIndicator';
import MessageBox from './components/MessageBox';
import Hierarchy from './components/Hierarchy';
import Notification from './components/Notification';
import FieldsMapping from './components/FieldsMapping';
import SmtpConfiguration from './components/SmtpConfiguration';
import LoggingEvents from './components/LoggingEvents';
import UnsupportedBrowserChecker from './components/UnsupportedBrowserChecker';
import SupportSideBar from './components/SupportSideBar';
import UsersMapping from './components/users/UsersMapping';
import ProfileFilters from './components/profile/filters/ProfileFilters';
import MigrationSettings from './components/MigrationSettings';
import store from './store';

Vue.config.productionTip = false;
Vue.component('icon', Icon);

Icon.register({
    'plus-thin': {
        width: 24,
        height: 24,
        d: 'M13 11V3.993A.997.997 0 0012 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 003 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0021 12c0-.556-.445-1-.993-1H13z',
    },
    'open-in-new-tab': {
        width: 24,
        height: 24,
        d: 'M5.175 20.975q-.9 0-1.525-.625-.625-.625-.625-1.525V5.175q0-.9.625-1.525.625-.625 1.525-.625h6.75v2.15h-6.75v13.65h13.65v-6.75h2.15v6.75q0 .9-.625 1.525-.625.625-1.525.625Zm4.75-5.4-1.5-1.5 8.9-8.9H13.8v-2.15h7.175V10.2h-2.15V6.675Z',
    },
});

Array.prototype.forEach.call(document.querySelectorAll('.vue-container'), (container) => {
	new Vue({
	  el: '#' + container.getAttribute("id"),
	  store,
	  components: {
	  	LinkMapping,
	  	WizardSide,
	  	NotificationHandler,
	  	HealthStatusIndicator,
	  	ProfileHealth,
	  	MessageBox,
	  	Hierarchy,
	  	Notification,
	  	FieldsMapping,
	  	SmtpConfiguration,
		LoggingEvents,
		UnsupportedBrowserChecker,
	  	SupportSideBar,
	  	UsersMapping,
        ProfileFilters,
		MigrationSettings,
	  },
	});
});



// WEBPACK FOOTER //
// ./src/main.js